import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-501df675"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "describe" }, "根据今日总股本计算所得，综合考虑分红送转、增发、新股上市等情况，可能会与最新报告期不一致。", -1))
const _hoisted_2 = { class: "zxzbul" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "clearfix" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright" }, "最新数据"),
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright" }, "最新数据"),
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright" }, "最新数据")
], -1))
const _hoisted_4 = { class: "clearfix" }
const _hoisted_5 = { class: "gray" }
const _hoisted_6 = {
  key: 0,
  class: "nametag"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "clearfix" }
const _hoisted_11 = { class: "onerow" }
const _hoisted_12 = { class: "two" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "clearfix" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright nopadding" }, [
    /*#__PURE__*/_createElementVNode("div", null, "最新数据"),
    /*#__PURE__*/_createElementVNode("div", null, "上年同期")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright nopadding" }, [
    /*#__PURE__*/_createElementVNode("div", null, "最新数据"),
    /*#__PURE__*/_createElementVNode("div", null, "上年同期")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright nopadding" }, [
    /*#__PURE__*/_createElementVNode("div", null, "最新数据"),
    /*#__PURE__*/_createElementVNode("div", null, "上年同期")
  ])
], -1))
const _hoisted_14 = { class: "clearfix" }
const _hoisted_15 = { class: "gray" }
const _hoisted_16 = { class: "ybtitle-tooltip" }
const _hoisted_17 = ["onMouseleave", "onMouseenter"]
const _hoisted_18 = {
  key: 0,
  class: "nametag"
}
const _hoisted_19 = { class: "nopadding clearfix" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "clearfix" }
const _hoisted_25 = { class: "onerow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _hoisted_1,
        _createElementVNode("ul", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("li", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'list1' + i
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                  (item.tip)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        title: item.tip
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InfoCircleOutlined)
                        ]),
                        _: 2
                      }, 1032, ["title"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    arrowPointAtCenter: "",
                    getPopupContainer: _ctx.getPopupContainer,
                    align: {
                offset: [0, 4],
              }
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("span", null, "数据来源：业绩" + _toDisplayString(item.tag) + "报，" + _toDisplayString(_ctx.moment(item.time * 1000).format('YYYY年')) + _toDisplayString(_ctx.setquarter(item.time *
                    1000)) + "季报", 1)
                    ]),
                    default: _withCtx(() => [
                      (item.tag && item.time)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.tag) + _toDisplayString(_ctx.moment(item.time * 1000).quarter()), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["getPopupContainer"])
                ]),
                _createElementVNode("div", {
                  class: "textright",
                  style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
                }, [
                  (item.slots && item.slots.customRender === 'peopleCount')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(Math.abs(item.num) >= 100000000 ? (item.num / 100000000).toFixed(2) + '亿' : Math.abs(item.num) >=
                  10000 ?
                  (item.num / 10000).toFixed(2) + '万' : parseFloat(item.num).toString() !== 'NaN' ? item.num : '—'), 1))
                    : (item.fixed == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(parseFloat(item.num).toString() !== 'NaN' ? (item.num || 0).toFixed(2) : '—'), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(parseFloat(item.num).toString() !== 'NaN' ? (item.num || 0).toFixed(4) : '—'), 1))
                ], 4)
              ], 64))
            }), 128))
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, " 数据来源：" + _toDisplayString(_ctx.moment(_ctx.EndDate * 1000).format('YYYY年')) + _toDisplayString(_ctx.setquarter(_ctx.EndDate * 1000)) + "季报，部分数据来自最新业绩快报; 其中每股收益字段均以最新总股本计算得出，精确到小数点后四位，其余指标若发生股本变动等情况则将重新计算。 ", 1)
          ])
        ]),
        _createElementVNode("ul", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("li", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (item, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'list2' + i
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_tooltip, {
                    placement: "topLeft",
                    visible: _ctx.overflow[item.name + i],
                    align: {
                offset: [0, 4],
              },
                    destroyTooltipOnHide: "",
                    mouseEnterDelay: 0.4
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "overflow",
                        onMouseleave: ($event: any) => (_ctx.hidetool(i, item.name)),
                        onMouseenter: ($event: any) => (_ctx.isoverflow($event, i)),
                        href: "javascript:void(0)"
                      }, [
                        _createTextVNode(_toDisplayString(item.name) + " ", 1),
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          arrowPointAtCenter: "",
                          getPopupContainer: _ctx.getPopupContainer,
                          align: {
                    offset: [0, 4],
                  }
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", null, "数据来源：业绩" + _toDisplayString(item.tag) + "报，" + _toDisplayString(_ctx.moment(item.time * 1000).format('YYYY年')) + _toDisplayString(_ctx.setquarter(item.time
                        *
                        1000)) + "季报", 1)
                          ]),
                          default: _withCtx(() => [
                            (item.tag && item.time)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.tag) + _toDisplayString(_ctx.moment(item.time * 1000).quarter()), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["getPopupContainer"])
                      ], 40, _hoisted_17)
                    ]),
                    _: 2
                  }, 1032, ["visible", "mouseEnterDelay"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "textright",
                    style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
                  }, [
                    (item.slots && item.slots.customRender === 'peopleCount')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(Math.abs(item.num) >= 100000000 ? (item.num / 100000000).toFixed(2) + '亿' : Math.abs(item.num) >=
                    10000 ?
                    (item.num / 10000).toFixed(2) + '万' : parseFloat(item.num).toString() !== 'NaN' ? item.num : '—'), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.num && item.num !== 0 ? (item.num || 0).toFixed(2) + '%' : '—'), 1))
                  ], 4),
                  _createElementVNode("div", {
                    class: "textright",
                    style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
                  }, [
                    (item.slots && item.slots.customRender === 'peopleCount')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(Math.abs(item.num0) >= 100000000 ? (item.num0 / 100000000).toFixed(2) + '亿' : Math.abs(item.num0)
                    >=
                    10000 ?
                    (item.num0 / 10000).toFixed(2) + '万' : parseFloat(item.num0).toString() !== 'NaN' ? item.num0 : '—'), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.num0 && item.num0 !== 0 ? (item.num0 || 0).toFixed(2) + '%' : '—'), 1))
                  ], 4)
                ])
              ], 64))
            }), 128))
          ]),
          _createElementVNode("li", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, " 数据来源：" + _toDisplayString(_ctx.moment(_ctx.EndDate1 * 1000).format('YYYY年')) + _toDisplayString(_ctx.setquarter(_ctx.EndDate1 * 1000)) + "季报(最新数据)，" + _toDisplayString(_ctx.moment(_ctx.EndDate1 *
                1000).add(-1, 'y').format('YYYY年')) + _toDisplayString(_ctx.setquarter(_ctx.EndDate1 * 1000)) + "季报(上年同期)，部分数据来自最新业绩快报。 ", 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}